import React, {useEffect, useState} from "react"
import {AppContext} from "../context/AppContext";
import $ from "jquery"
import {fetchAndReceiveJSON, moveToLink, phone_format, validatePhonenum} from "../utils/utils";
import Header from "../components/Header/Header.component";
import HambergerForHiddenNav from "../components/HambergerForHiddenNav/HambergerForHiddenNav.component";
import {topBanner} from "../@types/types";
import {apiUrl} from "../constants/constants";
import {toJS} from "mobx";
import "./LoginForm.scss"
import {useNavigate} from "react-router-dom";
import {Helmet} from "react-helmet";

function NameForm() {
    const {userDataStore} = React.useContext(AppContext);
    const {user} = userDataStore;
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [topBannerInfo, setTopBannerInfo] = useState<topBanner>();
    const EMOJIS_REGEX = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    const navigate = useNavigate()
    const lastnameId = '#lastname';
    const firstnameId = '#firstname';

    useEffect(() => {
        if (user) {
            setFirstName(user.firstName)
            setLastName(user.lastName)
        }
    }, [user])

    const errorClass = "error";
    const inputErrorClass = ".input-error";

    function doReg() {

        $(inputErrorClass).hide();
        $('input').removeClass('error');

        const lastname = $(lastnameId).val().trim();
        const firstname = $(firstnameId).val().trim();

        if (lastname == '') {
            showError(lastnameId);
            return;
        } else {
            hideError(lastnameId);
        }

        if (lastname.match(EMOJIS_REGEX)) {
            showError('#lastname_emoji');
            return;
        } else {
            hideError('#lastname_emoji');
        }

        if (firstname == '') {
            showError(firstnameId);
            return;
        } else {
            hideError(firstnameId);
        }
        if (firstname.match(EMOJIS_REGEX)) {
            showError('#firstname_emoji');
            return;
        } else {
            hideError('#firstname_emoji');
        }
        const data = {"first_name": firstName, "last_name": lastName};

        fetch(apiUrl + '/api/update/name', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }).then(res => (res.json()).then(result => {
            if (result.id) {
                navigate('/welcome')
            }
        }))
    }

    function showError(targetId) {

        $(targetId + '_' + errorClass).show();
        $(targetId).addClass(errorClass);

    }

    function hideError(targetId) {

        $(targetId + '_' + errorClass).hide();
        $(targetId).removeClass(errorClass);

    }


    return (
        <div className='login-form-wrapper'>
            <Helmet>
                <title>콜린스 - 기본정보 수정</title>
            </Helmet>
            <Header
                disableSearch={true}
                setIsSpinnerShow={null}
                topBannerData={{data: topBannerInfo}}
                topBannerEnabled={topBannerInfo && topBannerInfo.enabled}
                leftContent={
                    <>
                        <HambergerForHiddenNav className="dt"/>
                        <img
                            src="https://fly.gitt.co/collins/img/logo_b.svg"
                            className="header-logo fixed_logo mo"
                            style={{cursor: 'pointer'}}
                            onClick={(e) => {
                                moveToLink('/', e);
                            }}
                        />
                    </>
                }
                centerContent={
                    <>
                        <img
                            src="https://fly.gitt.co/collins/img/logo_b.svg"
                            className="header-logo fixed_logo dt"
                            style={{pointerEvents: 'all', cursor: 'pointer'}}
                            onClick={(e) => {
                                moveToLink('/', e);
                            }}
                        />
                    </>
                }
                rightContent={
                    <>
                        {/*<div*/}
                        {/*    style={{*/}
                        {/*        height: '40px',*/}
                        {/*    }}*/}
                        {/*    className="CartIconWidthNumberDt dt"*/}
                        {/*    onClick={(e) => {*/}
                        {/*        moveToLink('/cart', e);*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <CartWithNumberDt number={cartQuantity}/>*/}
                        {/*</div>*/}
                        <div
                            className="flex  mo"
                            // style ={{display: 'flex'}}
                        >
                            {/*<div*/}
                            {/*    className="CartIconWidthNumberMo "*/}
                            {/*    style={{marginRight: '10px'}}*/}
                            {/*    onClick={(e) => {*/}
                            {/*        moveToLink('/cart', e);*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    <CartWithNumberMo number={cartQuantity}/>*/}
                            {/*</div>*/}
                            <HambergerForHiddenNav/>
                        </div>
                    </>
                }
            />
            <div className={'content'}>
                <div>
                    <div className="form-content">
                        <div className="form-msgs">
                            <div className="form-msg1">기본정보 수정</div>
                        </div>
                        <form className="form-inputs m30" id="nameForm">
                            <input type="text" name="last_name" id="lastname"
                                   placeholder='성 (last name / 예:홍)'
                                   value={lastName} onChange={(e) => setLastName(e.target.value)}/>
                            <div id="lastname_error" className="input-error">성을 입력해 주세요</div>
                            <div id="lastname_emoji_error" className="input-error">이모티콘은 포함 할 수 없습니다.</div>
                            <input type="text" name="first_name" id="firstname"
                                   placeholder='이름 (first name / 예: 길동)' value={firstName}
                                   onChange={(e) => setFirstName(e.target.value)}/>
                            <div id="firstname_error" className="input-error">이름을 입력해 주세요</div>
                            <div id="firstname_emoji_error" className="input-error">이모티콘은 포함 할 수 없습니다.</div>
                            {/*<div id="server_error" th:if="${param.error != null}" className="input-error show m16"*/}
                            {/*     th:text="#{reg_form.server.error}"></div>*/}
                        </form>
                        <div className="green-btn">
                            <div className="cta-btn" onClick={() => doReg()}>
                                <div className="icon-text">수정하기</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div></div>
        </div>
    )

}

export default NameForm
